import getters from "./getters.js";
import actions from "./actions.js";
import mutations from "./mutations.js";

export default {
    namespaced: true,
    state() {
        return {
            languageList: [
                {
                    id: "tr",
                    langCode: "TR"
                },
                {
                    id: "en",
                    langCode: "EN"
                },
                {
                    id: "ar",
                    langCode: "AR"
                },
                {
                    id: "bg",
                    langCode: "BG"
                },
                {
                    id: "de",
                    langCode: "DE"
                },
                {
                    id: "es",
                    langCode: "ES"
                },
                {
                    id: "it",
                    langCode: "IT"
                },
                {
                    id: "ge",
                    langCode: "GE"
                },
                {
                    id: "kz",
                    langCode: "KZ"
                },
                {
                    id: "sr",
                    langCode: "SR"
                },
                {
                    id: "nl",
                    langCode: "NL"
                },
                {
                    id: "ro",
                    langCode: "RO"
                },
                {
                    id: "ru",
                    langCode: "RU"
                },
                {
                    id: "uk",
                    langCode: "UK"
                }
            ],
            activeLanguageList: [],
            translatedText:"",
            identifyedLanguage:""
        }
    },
    getters,
    actions,
    mutations
}